// extracted by mini-css-extract-plugin
module.exports = {"badge":"sy","isRental":"sz","badgeWrapper":"sA","hide":"sB","roundedBadge":"sC","gridBadge":"sD"};